import { Suspense } from "react";
import { ROUTES } from "../constants";
import { Routes, Route } from "react-router-dom";
import { PrivateRoute } from "../context/routes/privateRoutes";

// Other imports...
import Wallets from "../../pages/wallets";
import Onboarding from "../../components/onboarding";
import { isLoggedIn } from "../context/authContext";
import ContractNotFound from "../../pages/contract/notFound";
import UsersManagement from "../../pages/usersManagement";
import Organizations from "../../pages/organizations";
import Login from "../../pages/authentication/login";
import Payment from "../../pages/payment";
import ContractsList from "../../pages/contract/list";
import ContractRoute from "../context/routes/contractRoues";
import UserProfile from "../../pages/userProfile";
import HomeStats from "../../pages/homeStats";
import UserStats from "../../pages/userStats";
import Settings from "../../pages/settings";
import ContractProvider from "../../providers/contract/contract.provider";
import OrganstionProvider from "../../providers/organisation/organisation.provider";
import Settlements from "../../pages/settlements";
import Cashouts from "../../pages/cashouts";
import Alerts from "../../pages/alerts";
import CashoutDetails from "../../pages/cashouts/CashoutDetails";
import Withdraws from "../../pages/withdraws/Withdraws";
import WithdrawDetails from "../../pages/withdraws/WithdrawDetails";
import CompletedTransfers from "../../pages/completedTransfers/CompletedTransfers";
import Advertisement from "../../pages/advertisment";
import BusinessHome from "../../pages/business/home";
import CreateContract from "../../pages/business/create";
import Contracts from "../../pages/business/contracts";
import BusinessSettings from "../../pages/business/settings";
import BusinessUsers from "../../pages/business/users";
import BusinessUserProfile from "../../pages/business/userProfile";
import SettlementDetails from "../../pages/settlements/SettlementDetails";
import MultiCashouts from "../../pages/multiCashouts";
import MultiCashoutDetails from "../../pages/multiCashouts/MultiCashoutDetails";
import BusinessUpdates from "../../pages/business/updates";
import { AuthConfig } from "../context/config/authConfig";
import BusinessBalance from "../../pages/business/balance";
import { WalletProvider } from "../../providers/wallet/wallet.provider";
import BusinessTransactions from "../../pages/business/transactions";
import ContractsList_v2 from "../../pages/contract/list_v2";

interface Props {
  isAdmin: boolean;
  adminOrgEnabled?: boolean;
}

export const IndexRouter = ({ isAdmin, adminOrgEnabled }: Props) => {
  const authorities = AuthConfig.getUserInfo()?.authorities;

  return (
    <Suspense fallback={<div />}>
      <Routes>
        {/* Public and private routes */}
        <Route
          path={ROUTES.HOME}
          element={
            isLoggedIn() ? (
              isAdmin ? (
                <HomeStats />
              ) : (
                <BusinessHome />
              )
            ) : (
              <Login />
            )
          }
        />
        <Route path={ROUTES.ONBOARDING} element={<Onboarding />} />
        <Route
          path={ROUTES.CONTRACT_NOT_FOUND}
          element={<ContractNotFound />}
        />
        {!isAdmin &&
          (authorities?.includes("CLIENT_ADMIN_CREATE_CONTRACT") ||
            authorities?.includes("CLIENT_ADMIN") ||
            authorities?.includes("ORGANIZATION_OWNER")) && (
            <Route
              path={ROUTES.CREATE_COMPLEX_CONTRACT}
              element={<PrivateRoute />}>
              <Route index element={<CreateContract />} />
              <Route path=":id?" element={<CreateContract />} />
            </Route>
          )}
        <Route path={ROUTES.CONTRACTS_LIST} element={<PrivateRoute />}>
          <Route
            path={ROUTES.CONTRACTS_LIST}
            element={
              isAdmin ? <ContractsList isAdmin={isAdmin} /> : <Contracts />
            }
          />
        </Route>
        <Route path={ROUTES.CONTRACTS_LIST_V2} element={<PrivateRoute />}>
          <Route
            path={ROUTES.CONTRACTS_LIST_V2}
            element={isAdmin ? <ContractsList_v2 /> : <Contracts />}
          />
        </Route>
        {!isAdmin && (
          <Route path={ROUTES.LATEST_UPDATES} element={<PrivateRoute />}>
            <Route path={ROUTES.LATEST_UPDATES} element={<BusinessUpdates />} />
          </Route>
        )}
        {!isAdmin && (
          <Route path={ROUTES.BALANCE} element={<PrivateRoute />}>
            <Route
              path={ROUTES.BALANCE}
              element={
                <WalletProvider>
                  <BusinessBalance />
                </WalletProvider>
              }
            />
          </Route>
        )}
        {!isAdmin && (
          <Route path={ROUTES.MONEY_TRANSACTIONS} element={<PrivateRoute />}>
            <Route
              path={ROUTES.MONEY_TRANSACTIONS}
              element={
                <WalletProvider>
                  <BusinessTransactions />
                </WalletProvider>
              }
            />
          </Route>
        )}
        <Route path={ROUTES.SETTLEMENTS} element={<PrivateRoute />}>
          <Route path={ROUTES.SETTLEMENTS} element={<Settlements />} />
        </Route>
        <Route path={ROUTES.CASHOUTS} element={<PrivateRoute />}>
          <Route path={ROUTES.CASHOUTS} element={<Cashouts />} />
        </Route>
        <Route path={ROUTES.MULTI_CASHOUTS} element={<PrivateRoute />}>
          <Route path={ROUTES.MULTI_CASHOUTS} element={<MultiCashouts />} />
        </Route>
        <Route path={ROUTES.WITHDRAWS} element={<PrivateRoute />}>
          <Route path={ROUTES.WITHDRAWS} element={<Withdraws />} />
        </Route>
        <Route path={ROUTES.COMPLETED_TRANSFERS} element={<PrivateRoute />}>
          <Route
            path={ROUTES.COMPLETED_TRANSFERS}
            element={<CompletedTransfers />}
          />
        </Route>
        <Route path={ROUTES.ALERTS} element={<PrivateRoute />}>
          <Route path={ROUTES.ALERTS} element={<Alerts />} />
        </Route>
        <Route path={ROUTES.ADVERTISEMENT} element={<PrivateRoute />}>
          <Route path={ROUTES.ADVERTISEMENT} element={<Advertisement />} />
        </Route>
        <Route path={ROUTES.HOME} element={<PrivateRoute />}>
          <Route path={ROUTES.PAYMENT} element={<Payment />} />
        </Route>
        <Route path={ROUTES.HOME} element={<PrivateRoute />}>
          <Route path={ROUTES.STAT_USER_ID} element={<UserStats />} />
        </Route>
        <Route path={ROUTES.CONTRACT_DETAILS} element={<PrivateRoute />}>
          <Route
            path={ROUTES.CONTRACT_DETAILS}
            element={
              <ContractProvider>
                <ContractRoute isAdmin={isAdmin} />
              </ContractProvider>
            }
          />
        </Route>
        <Route path={ROUTES.CASHOUT_DETAILS} element={<PrivateRoute />}>
          <Route
            path={ROUTES.CASHOUT_DETAILS}
            element={
              <ContractProvider>
                <CashoutDetails />
              </ContractProvider>
            }
          />
        </Route>
        <Route path={ROUTES.MULTI_CASHOUT_DETAILS} element={<PrivateRoute />}>
          <Route
            path={ROUTES.MULTI_CASHOUT_DETAILS}
            element={<MultiCashoutDetails />}
          />
        </Route>
        <Route path={ROUTES.SETTLEMENT_DETAILS} element={<PrivateRoute />}>
          <Route
            path={ROUTES.SETTLEMENT_DETAILS}
            element={
              <ContractProvider>
                <SettlementDetails />
              </ContractProvider>
            }
          />
        </Route>
        <Route path={ROUTES.WITHDRAW_DETAILS} element={<PrivateRoute />}>
          <Route path={ROUTES.WITHDRAW_DETAILS} element={<WithdrawDetails />} />
        </Route>

        <Route path={ROUTES.SETTINGS} element={<PrivateRoute />}>
          <Route
            path={ROUTES.SETTINGS}
            element={isAdmin ? <Settings /> : <BusinessSettings />}
          />
        </Route>

        <Route path={ROUTES.USERS_MANAGEMENT} element={<PrivateRoute />}>
          <Route
            path={ROUTES.USERS_MANAGEMENT}
            element={
              isAdmin ? (
                <UsersManagement isAdmin={isAdmin} />
              ) : (
                <BusinessUsers />
              )
            }
          />
        </Route>
        <Route path={ROUTES.USER_DETAILS} element={<PrivateRoute />}>
          <Route path={ROUTES.USER_DETAILS} element={<BusinessUserProfile />} />
        </Route>

        {/* Admin Routes */}
        {isAdmin && (
          <>
            <Route path={ROUTES.HOME} element={<PrivateRoute />}>
              <Route path={ROUTES.PAYMENT} element={<Payment />} />
            </Route>
            <Route path={ROUTES.HOME} element={<PrivateRoute />}>
              <Route path={ROUTES.STAT_USER_ID} element={<UserStats />} />
            </Route>
            <Route path={ROUTES.HOME} element={<PrivateRoute />}>
              <Route path={ROUTES.PROFILE} element={<UserProfile />} />
            </Route>
            <Route path={ROUTES.PAYMENTS} element={<PrivateRoute />}>
              <Route path={ROUTES.PAYMENTS} element={<Wallets />} />
            </Route>

            {adminOrgEnabled && (
              <Route path={ROUTES.ORGANIZATIONS} element={<PrivateRoute />}>
                <Route
                  path={ROUTES.ORGANIZATIONS}
                  element={
                    <OrganstionProvider>
                      <Organizations />
                    </OrganstionProvider>
                  }
                />
              </Route>
            )}
          </>
        )}
      </Routes>
    </Suspense>
  );
};
